export default "__VITE_PUBLIC_ASSET__a25acae3__"